module.exports = __webpack_public_path__ + "static/media/files.899d5ac9.png";